import { Link } from "react-router-dom";
import { ShieldCheck, Info } from "lucide-react";

export const Footer = () => (
  <footer data-testid="footer-section" className="border-t border-white/10 bg-[#0A2E5C] px-4 sm:px-6 lg:px-8 pt-14 pb-28 md:pb-14">
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
        <div className="max-w-md">
          <div className="flex items-center gap-2 mb-4">
            <ShieldCheck className="w-5 h-5 text-[#7CC4F0]" />
            <span className="font-heading font-bold text-sm text-white">
              DESPACHANTES<span className="text-[#7CC4F0]">DETRAN</span>.COM.BR
            </span>
          </div>
          <p className="text-xs text-slate-300/80 leading-relaxed">
            Encaminhamento de solicitações de serviços de documentação de veículos —
            transferência, licenciamento, emplacamento, vistoria e regularização — para
            despachantes e profissionais qualificados em todo o Brasil.
          </p>
        </div>
        <div className="flex flex-col gap-3 text-sm">
          <a href="#como-funciona" data-testid="footer-link-como-funciona" className="text-slate-300 hover:text-[#7CC4F0] transition-colors">Como funciona</a>
          <a href="#servicos" data-testid="footer-link-servicos" className="text-slate-300 hover:text-[#7CC4F0] transition-colors">Serviços</a>
          <a href="#solicitar" data-testid="footer-link-solicitar" className="text-slate-300 hover:text-[#7CC4F0] transition-colors">Solicitar atendimento</a>
          <Link to="/privacidade" data-testid="footer-link-privacidade" className="text-slate-300 hover:text-[#7CC4F0] transition-colors">Política de Privacidade</Link>
        </div>
      </div>

      <div className="mt-12 rounded-2xl border border-white/10 bg-white/[0.04] p-5 flex gap-3">
        <Info className="w-4 h-4 text-slate-300 shrink-0 mt-0.5" />
        <p data-testid="footer-disclaimer" className="text-[11px] text-slate-300 leading-relaxed">
          Este é um serviço privado de encaminhamento de solicitações e não possui vínculo oficial
          com o DETRAN ou órgãos públicos.
        </p>
      </div>

      <p className="text-[11px] text-slate-400 mt-8 text-center">
        © {new Date().getFullYear()} despachantesdetran.com.br — Todos os direitos reservados.
      </p>
    </div>
  </footer>
);
